module.exports = __webpack_public_path__ + "h5/img/water_bg.3f801634.jpg";